export default {
    //英语
    DiagnosticReport:'Diagnostic report',
    troubleCode:'Fault code',
    time:'time',
    noTItle:'Manufacturer control',
    TestReport:'Test Report',
    VehicleInformation:'Vehicle Information',
    DataStream:'Data stream',
    IMReadiness:'I/M Readiness',
    Communication:'Communication protocol',
    notFaultCode:'No fault code',
    nodataflow:'No abnormal data flow',
    // 语言
    lang:{
        cn:'Chinese',
        de:'German',
        en:'English',
        es:'Spanish',
        fr:'French',
        it:'Italian',
        ja:'Japanese',
        ko:'Korean',
        pt:'Portuguese'
    },
    PositioningPrompt:'Enable the location function to obtain local prices',
    FaultCode:'Fault code',
    AIDiagnosis:'AI diagnosis',
    AIWait:'AI report or wait for automatic diagnosis',
    FailedFaultCode:'Unable to obtain fault code information',
    AIError:'AI analysis failure',
    more:'more',
    StoredCodes:'store code',
    PendingCodes:'Code to be processed',
    PermanentCodes:'permanent encoding',
    Unknown:'unknown',
    ManufacturerControl:'manufacturer control'
}